<template>
  <PTransparentLoader :loading="loading">
    <div v-if="orderDetail">
      <div class="d-flex align-items-center mb-3">
        <CLink
          style="color: #100F23"
          class="mr-4"
          @click="goBack"
        >
          <CIcon size="custom-size" :width="18" name="cipArrowNarrowLeft" class="mr-2"/>
          <translate translate-context="accounting.order">Back</translate>
        </CLink>
        <h1 class="main-header mb-0">
          <translate translate-context="accounting.orderDetail">Order</translate>
          {{ orderDetail.order_number || `#${orderDetail.id}` }}
        </h1>
      </div>

      <!-- Order Header (reuse) -->
      <OrderHeader :order="orderDetail"/>

      <!-- User Info -->
      <UserInfo
        :user="userInfo"
        :user-id="userId"
        :current-source-id="orderDetail.id"
        :current-checkin-picacodes="orderPicacodes"
        :scope="scope"
        v-if="userId"
      />

      <!-- Recent Disputes (only if any) -->
      <RecentChargebacks
        v-if="userId"
        :user-id="userId"
        :scope="scope"
        :current-order-id="orderDetail.id"
      />

      <!-- Order Items -->
      <div class="order-section">
        <div>
          <OrderItemBlock
            v-for="(item, idx) in orderItems"
            :key="item.id"
            :item="item"
            :item-detail="getOrderItemDetail(item.id)"
            :item-loading="getOrderItemLoading(item.id)"
            :scope="scope"
            :currency="orderDetail.currency || 'EUR'"
            :expanded-initially="idx === 0"
          />
        </div>
      </div>

      <!-- Ledger Entries (ordine intero) -->
      <div class="order-section" v-if="hasLedgerEntries">
        <OrderLedgerEntries
          :entries="orderDetail.ledger_entries"
          :order-items="orderItems"
        />
      </div>
    </div>
  </PTransparentLoader>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import PTransparentLoader from '@/domain/core/components/PTransparentLoader.vue'
import OrderHeader from './components/OrderHeader.vue'
import UserInfo from '../components/UserInfo.vue'
import OrderItemBlock from './components/OrderItemBlock.vue'
import OrderLedgerEntries from './components/OrderLedgerEntries.vue'
import RecentChargebacks from '../chargeback/RecentChargebacks.vue'
export default {
  name: 'OrderDetail',
  components: {
    PTransparentLoader,
    OrderHeader,
    UserInfo,
    OrderItemBlock,
    OrderLedgerEntries,
    RecentChargebacks
  },
  data() {
    return {
      loading: true
    }
  },
  async mounted() {
    await this.setScope(this.scope)
    await this.fetchScopedConfig()
    await this.loadOrder()
  },
  watch: {
    '$route.params.id'() {
      this.loadOrder()
    }
  },
  computed: {
    ...mapGetters('accounting/order', ['orderDetail', 'getOrderItemDetail', 'getOrderItemLoading']),

    scope() {
      return {
        type: 'global',
        id: null
      }
    },

    orderItems() {
      if (!this.orderDetail) return []
      return this.orderDetail.items || this.orderDetail.order_items || []
    },

    userId() {
      return this.orderDetail?.user_id || null
    },

    userInfo() {
      return this.orderDetail?.user_info || null
    },

    orderPicacodes() {
      return this.orderItems
        .map(item => item.picacode)
        .filter(Boolean)
    },

    hasLedgerEntries() {
      return this.orderDetail?.ledger_entries?.length > 0
    }
  },
  methods: {
    ...mapActions('accounting', ['setScope']),
    ...mapActions('accounting/order', ['fetchOrderDetail']),
    ...mapActions('login', ['fetchConfig']),

    async fetchScopedConfig() {
      try {
        await this.fetchConfig({type: 'accounting_global'})
      } catch (e) {
        // Config endpoint may not exist yet
      }
    },

    goBack() {
      this.$router.push({name: 'admin.accounting'})
    },

    async loadOrder() {
      this.loading = true
      try {
        await this.fetchOrderDetail(this.$route.params.id)
      } finally {
        this.loading = false
      }
    },

  }
}
</script>

<style scoped>
.order-section {
  padding: 20px 0;
  border-bottom: 1px solid #e4e7ea;
}

.order-section:last-of-type {
  border-bottom: none;
}

.order-section__header {
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: #333;
}

.reference-link {
  color: #e67e22;
  text-decoration: none;
}

.reference-link:hover {
  color: #d35400;
}
</style>
